import { render, staticRenderFns } from "./UnifiedLoginView.vue?vue&type=template&id=ed89aa9a&scoped=true"
import script from "./UnifiedLoginView.vue?vue&type=script&lang=js"
export * from "./UnifiedLoginView.vue?vue&type=script&lang=js"
import style0 from "./UnifiedLoginView.vue?vue&type=style&index=0&id=ed89aa9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed89aa9a",
  null
  
)

export default component.exports